export type SortActivityMode = 'name' | 'number';
export const defaultSortActivityMode: SortActivityMode = 'number';
